/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { Log } from '../../models/log';

export interface AddLog$Params {
   id: string;
}

export function addLog(
   http: HttpClient,
   rootUrl: string,
   params: AddLog$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<Array<Log>>> {
   const rb = new RequestBuilder(rootUrl, addLog.PATH, 'delete');
   if (params) {
      rb.path('id', params.id, {});
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<Array<Log>>;
      })
   );
}

addLog.PATH = '/api/weather/log/{id}/userInfo';
